import { render, staticRenderFns } from "./DrugsDictionary.vue?vue&type=template&id=b8110734&lang=pug&"
import script from "./DrugsDictionary.vue?vue&type=script&lang=js&"
export * from "./DrugsDictionary.vue?vue&type=script&lang=js&"
import style0 from "./DrugsDictionary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports